<template>
	<div class="container">
		<h1>404 Page Not Found</h1>	
	</div>	
</template>

<script>
	export default {
		mounted() {
      let footer = document.querySelector('footer')
      footer.classList.add('display-none')
    },
    destroyed() {
      let footer = document.querySelector('footer')
      footer.classList.remove('display-none')
    }
	}
</script>

<style lang="scss" scoped>
	.container {
		height: calc(100vh - 66px);
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	h1 {
		font-size: 4rem;
		font-family: 'Roboto', sans-serif;
		color: #B0BEC5;
	}
	@media screen and (min-width: 769px) {
		.container {
			height: calc(100vh - 82px);
		}
	}
	@media screen and (min-width: 1216px) {
		h1 {
			font-size: 6rem;
		}
	}

</style>